import React from 'react'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import Toggle from 'react-toggle'
import styled from 'styled-components'
// import './styles.scss'

interface Props {
  sort: boolean
  setSort: React.SetStateAction<any>
  labels: string[]
}

export const SortToggle = ({ sort, setSort, labels }: Props) => {
  return (
    <SortToggleRoot className='toggleWrapper'>
      {/* <div className='toggleTitle'>{labels[0]}</div> */}
      <div className='switchcontainer'>
        <div className={'label ' + (!sort ? '' : 'off')}>{labels[1]}</div>
        <div className='toggleContainer'>
          <Toggle
            defaultChecked={sort}
            icons={false}
            onChange={e => {
              setSort(e.target.checked)
            }}
          />
        </div>
        <div className={'label right ' + (sort ? '' : 'off')}>{labels[2]}</div>
      </div>
    </SortToggleRoot>
  )
}


const SortToggleRoot = styled.div`
  flex: 0 0 200px;
  line-height: 0;
  color: var(--text-color);
  font-family: var(--font-sans-serif);
  width: calc(100%);
  padding-left: 1.6em;
  padding-right: 16px;
  padding-top: 10px;

  font-size: 0.9em;
  // border-bottom: 1px solid #f0f0f2;

  &:last-of-type {
    border: 0;
  }
  .toggleTitle {
    width: 30%;
    line-height: 1.6em;
    font-weight: 700;
    float: left;
    @media only screen and (max-width: 599px) {
      width: 100%;
    }
  }
  .switchcontainer {
    width: 100%;
    display: inline-block;
    display: flex;

    @media only screen and (max-width: 599px) {
      width: 100%;
    }
  }
  .label {
    font-weight: 200;
    font-size: 0.9em;
    text-align: right;
    padding-top: 0.1em;
    padding-right: 10px;
    float: left;
    line-height: 1.3em;
    width: calc(50% - 30px);
    flex: 0 0 calc(50% - 30px);
    &.right {
      padding-left: 10px;
      text-align: left;
    }
  }

  .toggleContainer {
    float: left;
    width: 60px;
  }
}

.react-toggle {
  touch-action: pan-x;
  display: inline-block;
  position: relative;
  cursor: pointer;
  background-color: transparent;
  border: 0;
  padding: 0;

  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
}

.react-toggle-screenreader-only {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.react-toggle--disabled {
  cursor: not-allowed;
  opacity: 0.5;
  -webkit-transition: opacity 0.25s;
  transition: opacity 0.25s;
}

.react-toggle-track {
  width: 50px;
  height: 24px;
  padding: 0;
  border-radius: 30px;
  background-color: var(--beige-bright-1);
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  transition: all 0.2s ease;
}

.react-toggle:hover:not(.react-toggle--disabled) .react-toggle-track {
  background-color: var(--text-color);
}

.react-toggle--checked .react-toggle-track {
  background-color: var(--beige-bright-1);
}

.react-toggle--checked:hover:not(.react-toggle--disabled) .react-toggle-track {
  background-color: var(--text-color);
}

.react-toggle-track-check {
  position: absolute;
  width: 14px;
  height: 10px;
  top: 0px;
  bottom: 0px;
  margin-top: auto;
  margin-bottom: auto;
  line-height: 0;
  left: 8px;
  opacity: 0;
  -webkit-transition: opacity 0.25s ease;
  -moz-transition: opacity 0.25s ease;
  transition: opacity 0.25s ease;
}

.react-toggle--checked .react-toggle-track-check {
  opacity: 1;
  -webkit-transition: opacity 0.25s ease;
  -moz-transition: opacity 0.25s ease;
  transition: opacity 0.25s ease;
}

.react-toggle-track-x {
  position: absolute;
  width: 10px;
  height: 10px;
  top: 0px;
  bottom: 0px;
  margin-top: auto;
  margin-bottom: auto;
  line-height: 0;
  right: 10px;
  opacity: 1;
  -webkit-transition: opacity 0.25s ease;
  -moz-transition: opacity 0.25s ease;
  transition: opacity 0.25s ease;
}

.react-toggle--checked .react-toggle-track-x {
  opacity: 0;
}

.react-toggle-thumb {
  transition: all 0.5s cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  position: absolute;
  top: 1px;
  left: 1px;
  width: 22px;
  height: 22px;
  border: 1px solid #4d4d4d;
  border-radius: 50%;
  background-color: #fafafa;

  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;

  -webkit-transition: all 0.25s ease;
  -moz-transition: all 0.25s ease;
  transition: all 0.25s ease;
}

.react-toggle--checked .react-toggle-thumb {
  left: 27px;
  border-color: #a09c8a;
}

.react-toggle--focus .react-toggle-thumb {
  -webkit-box-shadow: 0px 0px 3px 2px #0099e0;
  -moz-box-shadow: 0px 0px 3px 2px #0099e0;
  box-shadow: 0px 0px 2px 3px #0099e0;
}

.react-toggle:active:not(.react-toggle--disabled) .react-toggle-thumb {
  -webkit-box-shadow: 0px 0px 5px 5px #0099e0;
  -moz-box-shadow: 0px 0px 5px 5px #0099e0;
  box-shadow: 0px 0px 5px 5px #0099e0;




`